import * as React from 'react';
import Grid, { GridColumn } from '@telia-front/grid';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
import Separator from '@telia-front/separator';
import { TableCell, TableRow } from '@telia-front/table';
import { TvComparisonContext } from './index';
import ChannelPriceTableCell from './channel-price-table-cell';
import ChannelTooltip from './channel-tooltip';
const DesktopChannelRow = (props) => {
    const { channel, numberOfPackets } = props;
    const { soundLabel, subTitlesLabel } = React.useContext(TvComparisonContext);
    return (React.createElement(TableRow, { id: channel.id },
        React.createElement(TableCell, { width: numberOfPackets <= 1 ? 4 : 3 },
            React.createElement(Grid, { gutter: "none" },
                React.createElement(GridColumn, null,
                    React.createElement(Grid, { noWrap: true, align: ['middle-xs'], verticalGutter: "none", gutter: "small" },
                        React.createElement(GridColumn, { width: ['min'] },
                            React.createElement(Image, Object.assign({}, channel.image, { shape: "circle", width: 40 }))),
                        React.createElement(GridColumn, { width: ['max'] },
                            React.createElement(ChannelTooltip, { channel: channel }),
                            channel.exclusiveLabel && (React.createElement(Grid, { noWrap: true, align: ['top-xs'], verticalGutter: "none", gutter: "xsmall" },
                                React.createElement(GridColumn, { width: ['min'] },
                                    React.createElement(Icon, { modifiers: "#star", align: "middle", size: "xxs" })),
                                React.createElement(GridColumn, { width: ['max'] },
                                    React.createElement("span", { className: "text-small" }, channel.exclusiveLabel)))),
                            (channel.sound || channel.subTitles) && (React.createElement(React.Fragment, null,
                                React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                                React.createElement("p", { className: "text-light text-tiny" },
                                    channel.sound && (React.createElement(React.Fragment, null,
                                        React.createElement("strong", null,
                                            soundLabel,
                                            ":"),
                                        " ",
                                        channel.sound,
                                        React.createElement("br", null))),
                                    channel.subTitles && (React.createElement(React.Fragment, null,
                                        React.createElement("strong", null,
                                            subTitlesLabel,
                                            ":"),
                                        " ",
                                        channel.subTitles)))))))))),
        channel.packetPrices.map((price, index) => (React.createElement(ChannelPriceTableCell, { price: price, width: numberOfPackets <= 1 ? 2 : 3, key: index })))));
};
export default DesktopChannelRow;
